import { NodeWrapper } from "./NodeWrapper";
import { AccessTimeOutlined as AccessTime, ArrowForwardIosOutlined as ArrowForwardIos, ContentCopyOutlined as ContentCopy, DeleteOutlined as Delete, MessageOutlined as Message } from '@mui/icons-material';
import React, { memo } from "react";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { i18n } from "../../../translate/i18n";

import { Tooltip, IconButton } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import { HelpOutline as HelpOutlineIcon } from '@mui/icons-material';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#1e293b',
    color: '#f8fafc',
    maxWidth: 380,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #334155',
    padding: '12px 14px',
    borderRadius: '8px',
    fontFamily: "'Inter', 'Roboto', sans-serif",
    lineHeight: 1.5,
  },
  arrow: { color: '#1e293b' },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  pulseIcon: {
    color: '#ffffff',
    borderRadius: '50%',
    animation: '$glowPulse 1.5s infinite',
  },
  '@keyframes glowPulse': {
    '0%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0.9)' },
    '70%': { boxShadow: '0 0 0 8px rgba(255, 255, 255, 0)' },
    '100%': { boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' },
  },
}));
export default memo(({
  data,
  isConnectable,
  id,
  selected
}) => {
  const classes = useStyles();
  const storageItems = useNodeStorage();
  return <NodeWrapper id={id} selected={selected} color="#FFC400">
      {/* Floating Toolbar */}
      

      <Handle type="target" position="left" style={{
      background: "#FFC400",
      width: "10px",
      height: "20px",
      borderRadius: "4px",
      left: "-12px",
      cursor: "pointer",
      border: '2px solid white',
      top: "20px"
    }} onConnect={params => console.log("handle onConnect", params)} isConnectable={isConnectable}>
      </Handle>

      {/* Header */}
      <div style={{
      color: "#1a1a1a",
      fontSize: "14px",
      flexDirection: "row",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 12px",
      borderBottom: "1px solid #fff7ed",
      backgroundColor: "#FFC400",
      
      borderTopLeftRadius: "10px",
      borderTopRightRadius: "10px"
    }}>
        <AccessTime sx={{ width: "20px", height: "20px", color: "#ffffff", filter: "drop-shadow(0px 1px 3px rgba(0,0,0,0.7))" }} />
             <div style={{ color: "#ffffff", fontSize: "14px", fontWeight: "700", letterSpacing: "0.3px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", textShadow: "0px 1px 4px rgba(0,0,0,0.8)" }}>
              {i18n.t("flowBuilder.editor.nodes.interval.name")}
             </div>
      
        <div style={{ display: "flex", alignItems: "center", marginLeft: "auto" }}>
          <HtmlTooltip
            title={
              <React.Fragment>
                <div style={{ fontSize: '13px', fontWeight: 'bold', marginBottom: '8px', color: '#38bdf8' }}>
                  💡 {i18n.t("flowBuilder.tooltips.interval.title")}
                </div>
                <div style={{ marginBottom: '0' }}>
                  <div dangerouslySetInnerHTML={{ __html: i18n.t("flowBuilder.tooltips.interval.body") }} />
                </div>
              </React.Fragment>
            }
            placement="right"
          >
            <IconButton size="small" style={{ padding: '4px', marginLeft: '2px' }} className={classes.pulseIcon}>
              <HelpOutlineIcon style={{ fontSize: '15px' }} />
            </IconButton>
          </HtmlTooltip>
        </div>
</div>

      <div style={{
        padding: "12px",
        backgroundColor: "#ffffff",
        borderBottomLeftRadius: "10px",
        borderBottomRightRadius: "10px",
      }}>
        <div style={{
          position: "relative",
          backgroundColor: "#f8fafc",
          borderRadius: "8px",
          padding: "8px 10px",
          border: "1px solid #e2e8f0",
          color: "#334155",
          fontSize: "12px",
          fontWeight: "400"
        }}>
          <span style={{ color: "#64748b", fontSize: "11px", fontWeight: "400" }}>{i18n.t("flowBuilder.nodes.interval.pauseTime") || "Tiempo de pausa:"}</span><br />
          <span style={{
          fontSize: "13px",
          fontWeight: "500",
          color: "#334155"
        }}>
          {(() => {
            const sec = data?.sec || 0;
            if (sec > 0 && sec % 86400 === 0) return `${sec / 86400} días`;
            if (sec > 0 && sec % 3600 === 0) return `${sec / 3600} horas`;
            if (sec > 0 && sec % 60 === 0) return `${sec / 60} minutos`;
            return `${sec} segundos`;
          })()}
          </span>
          <Handle type="source" position="right" id="a" style={{
            position: "absolute", right: -25, top: "50%", transform: "translateY(-50%)", background: "#FFC400", width: 10, height: 20, cursor: "pointer", borderRadius: "4px", border: '2px solid white', zIndex: 1
          }} isConnectable={isConnectable} />
        </div>
      </div>
    </NodeWrapper>;
});
